<template>
  <div class="container-fluid">
    <div class="row container-showcase align-start justify-space-between">
      <!--      player-->
      <v-col
        cols="12"
        class="wow fadeInLeftBig col-lg-7 col-xl-7 player"
        style="position: relative"
      >
        <player
          :poster-url="ctnShowcase.url_poster"
          :is-control-scene="true"
          :video-plr="video"
          @nextScene="onNextMainScene"
          @preScene="onPreMainScene"
        >
          <template v-slot:ads>
            <div v-for="(shop, idxShop) in shops" :key="idxShop">
              <div
                class="movingElement"
                :style="{
                  left: shop.x + 'px',
                  top: shop.y + 'px',
                  width: shop.width + 'px',
                  height: shop.height + 'px',
                  border: showRecBoxProd ? '1px solid red' : '',
                }"
                @mouseover="showShopping(shop)"
                @mouseleave="hideShopping()"
              >
                <div @click="onclickBuyNow(shop)" class="buy-now show"></div>
              </div>
              <div
                v-show="
                  showInfoProd &&
                  !slotPanel &&
                  Math.round(new Date().getTime() / 1000) - shop.timeStart <
                    expireLabel
                "
                :id="shop.idStyle"
              >
                <!--                text info-->
                <div
                  class="fixedElement"
                  style="
                    position: absolute;
                    color: white;
                    pointer-events: all;
                    display: block;
                  "
                  :style="{
                    left: shop.textData.x + 'px',
                    top: shop.textData.y + 'px',
                    height: heightText + 'px',
                  }"
                >
                  <div id="wrapperDiv" class="wow wrapper">
                    <div
                      class="box-line"
                      style="
                        border-color: rgb(250, 250, 250);
                        visibility: inherit;
                        opacity: 1;
                        transform: matrix(1, 0, 0, 1, 0, 0);
                        transform-origin: left 50% 0;
                      "
                    ></div>
                    <div
                      class="mainTag"
                      style="
                        color: rgb(34, 34, 34);
                        visibility: inherit;
                        opacity: 1;
                      "
                    >
                      <div class="mainInfo">
                        <h2 style="color: white">{{ shop.name }}</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <!--                lineAnimate-->
                <div
                  class="lineElement"
                  :style="{
                    left: shop.lineData.x + 'px',
                    top: shop.lineData.y + 'px',
                    height: '1px',
                    width: shop.lineData.width + 'px',
                    transform: 'rotate(' + shop.lineData.rotate + 'deg)',
                  }"
                >
                  <div class="animate-line"></div>
                </div>
              </div>
              <!--              info page product-->

              <!--        top left-->
            </div>
            <div
              v-if="!slotPanel && showShopInfo"
              class="wow zoomIn panel-in-player d-flex align-center justify-center"
              style="position: absolute"
            >
              <v-col
                sm="12"
                xs="12"
                md="12"
                lg="10"
                xl="10"
                style="position: relative"
                class="container-prod"
              >
                <product :product="showShopInfo" />
              </v-col>
              <div style="position: absolute; top: 6px; right: 8px">
                <v-icon @click="showShopInfo = null">{{ mdiClose }}</v-icon>
              </div>
            </div>
          </template>
        </player>
        <content-same-showcase
          :title="ctnShowcase.title"
          :type-show-case="Number(ctnShowcase.type_showcase)"
          :showcase-id="ctnShowcase.showcase_id"
          @selectContent="handleChangeContent"
        />
      </v-col>
      <!--      panel-->
      <v-col
        cols="12"
        class="col-xl-5 col-lg-5 mt-lg-0 mt-md-12 mt-sm-12 mt-xs-12"
      >
        <div class="title-demo">
          <h5 v-html="`Demo ${$t('interactive_video_title')}`"></h5>
          <span>
            {{ $t("interactive_video_des") }}
          </span>
        </div>
        <transition name="slide-fade">
          <div
            v-if="
              this.$vuetify.breakpoint.name === 'xl' ||
              this.$vuetify.breakpoint.name === 'lg'
            "
            class="wow fadeInRight"
            style="position: relative"
          >
            <v-card
              width="100%"
              min-height="300px"
              height="auto"
              style="z-index: 2"
            >
              <v-card-text>
                <div
                  class="pa-xl-6 pa-lg-4"
                  style="max-height: 500px; overflow-y: auto"
                >
                  <div
                    v-if="showShopInfo"
                    class="wow fadeInUp mb-2"
                    :id="`btn-${showShopInfo.id}`"
                  >
                    <product :product="showShopInfo" />
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <div class="close-panel" v-if="showPrPanel" role="user">
              <div class="title-panel-close justify-space-between">
                <small class="mr-4">Product panel</small>
              </div>
            </div>
          </div>
        </transition>
      </v-col>
    </div>
  </div>
</template>

<script>
import { playerShowcase } from "../../minxin/player-showcase";
import _ from "lodash";
import ContentSameShowcase from "./components/ContentSameShowcase";
import Player from "./components/Player";
import Product from "./components/Product";
import { mdiClose } from "@mdi/js";
export default {
  name: "InteractiveVideo",
  components: { Product, Player, ContentSameShowcase },
  mixins: [playerShowcase],
  created() {
    switch (this.$vuetify.breakpoint.name) {
      case "lg":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      case "xl":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      default:
        this.showPrPanel = false;
        this.slotPanel = false;
        break;
    }
  },
  data() {
    return {
      showShopInfo: null,
      reload: 0,
      mdiClose: mdiClose,
    };
  },
  watch: {
    shops(val) {
      console.log(val);
    },
    showShopInfo(val) {
      if (val === null) {
        this.plyr.play();
      }
    },
  },
  methods: {
    _getMetaDataInTime(data, currentTimeVideo) {
      /*
      So sanh và get meta data tại thời điểm  hiện tại video display
      */
      return (
        _.filter(data, (o) => {
          return (
            o["itv"][0] <= currentTimeVideo && o["itv"][1] >= currentTimeVideo
          );
        }) || []
      );
    },
    onclickBuyNow(shop) {
      this.showShopping(shop, true);
    },
    showShopping(shop, force = false) {
      if (
        !force &&
        (this.$vuetify.breakpoint.name === "xl" ||
          this.$vuetify.breakpoint.name === "lg")
      ) {
        return;
      }
      shop.timeStart = Math.round(new Date().getTime() / 1000);
      this.showShopInfo = shop;
      if (
        this.$vuetify.breakpoint.name !== "xl" &&
        this.$vuetify.breakpoint.name !== "lg"
      ) {
        this.plyr.pause();
      }

      this.hideShopping();
    },
    hideShopping() {
      const hideShop = () => {
        this.showShopInfo = null;
      };
      setTimeout(() => {
        hideShop();
      }, 100000);
    },
    onNextScene() {},
    onPreScene() {},
  },
};
</script>

<style scoped lang="scss">
@import "https://cdn.plyr.io/3.6.7/plyr.css";
@import "../../styles/player.scss";
@import "../../styles/new_tag.scss";
</style>
